<script lang="ts">
    import { getContext, onDestroy } from 'svelte'
    import { get } from 'svelte/store'
    import type { Readable } from 'svelte/store'

    import type { GenOrder, IOrder } from '../../order'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'

    const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder

    interface Props {
        onSuccess: (ptype: string) => void
    }

    let { onSuccess }: Props = $props()

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let order: IOrder = $state(get(Order.orderStore))

    interface IForm {
        user_instructions: string
    }

    let form: IForm = $state({
        user_instructions: '',
    })

    unsubs.push(
        Order.orderStore.subscribe((v) => {
            order = v
            form.user_instructions = order.user_instructions ? order.user_instructions : ''
        }),
    )

    let error: string | undefined = $state()

    let working = $state(false)

    async function submit() {
        working = true
        error = undefined

        const data: any = { ...form }
        data.revision = order.revision
        data.total = order.total

        let r: SimpleFetchResult
        try {
            r = await simpleFetch('POST', `/json/ecom/1/order/${$orderId}/activate-cart-items`, data)
        } catch (e: any) {
            console.error('Failed to process payment:', e)
            working = false
            error = e && e.data && e.data.error ? e.data.error : '?'
            notify({
                type: 'danger',
                title: $_('Payment'),
                text: $_('Une erreur s’est produite lors du paiement : {error}', { error: error }),
            })
            return
        }
        Order.loadGenericResponse(r.data)
        onSuccess('bill later')
    }
</script>

<form
    onsubmit={(e) => {
        e.preventDefault()
        submit()
    }}
    class="d-grid gap-2"
    novalidate
>
    {#if error}
        <div class="help-text alert alert-danger alert-card">
            <p>{error}</p>
        </div>
    {/if}

    <p>{$_('The order will be activated, but not marked as paid.')}</p>

    <div class="row">
        <label for="user_instructions" class="col-sm-3 col-form-label">{$_('Instructions')}</label>
        <div class="col-sm-9">
            <textarea name="user_instructions" id="user_instructions" rows="2" placeholder={$_('Additional instructions or notes to be placed on the invoice.')} class="form-control" disabled={working} bind:value={form.user_instructions}></textarea>
        </div>
    </div>
    <div class="tab-footer text-end">
        <button type="submit" class="btn" disabled={working} class:btn-outline-secondary={working} class:btn-primary={!working}>
            {#if working}
                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                {$_('Processing…')}
            {:else}
                {$_('Change status to “unpaid” without activating any item.')}
            {/if}
        </button>
    </div>
</form>
